<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>PART III</span></p>
<p class="chap-title-2"><span>THE ARCHIVES</span></p>
<p class="normal-a">R<span class="smallcaps">EGULATIONS FOR</span> U<span class="smallcaps">SE OF THE</span> H<span class="smallcaps">ARVARD</span> U<span class="smallcaps">NIVERSITY</span> A<span class="smallcaps">RCHIVES</span></p>
<p class="indent-n"><i>1. The reading room is exclusively for use of Archives materials</i>.</p>
<p class="indent-n"><i>2. All material must be handled with care</i>.</p>
<p class="indent-n"><i>3. The use of pens is prohibited; only pencils may be used</i>.</p>
<p class="indent-n"><i>4. Coats, briefcases, and bags must be left in the closet by the Reference Desk …</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part3chapter01.vue?791e6d44